import Vue, { createApp } from 'vue';
import App from './UI/TheApp.vue';
import { createPinia } from 'pinia';
import ShareNetwork from './share/sharing';
import './UI/styles/index.css';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { PiniaUndo } from 'pinia-undo';
import router from './router';
import TheMask from 'vue-the-mask';

// Vue.config.productionTip = false
const pinia = createPinia();
const app = createApp(App);
app.use(TheMask);
app.use(router);
pinia.use(PiniaUndo);
// pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.use(ShareNetwork);
app.mount('#configurator-app');
